import React from 'react';
import { Typography, Card, Space, Divider, Grid } from 'antd';

const { useBreakpoint } = Grid;

const { Title, Paragraph } = Typography;

const AboutPage = () => {
  const screens = useBreakpoint();
  
  return (
    <Card style={{ 
      borderRadius: 12, 
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.03)',
      padding: screens.md ? '24px' : '16px'
    }}>
      <Space direction="vertical" size={screens.md ? 'large' : 'middle'} style={{ width: '100%' }}>
        <Title level={screens.md ? 2 : 3} style={{ color: '#3a0ca3', fontWeight: 'bold', marginBottom: screens.md ? '16px' : '12px' }}>关于 emusprint</Title>
        <Paragraph style={{ fontSize: screens.md ? '16px' : '14px' }}>
          emusprint 是一个专注于移动应用包管理的平台，提供了丰富的包数据信息，支持多种筛选和查询功能。
        </Paragraph>
        
        <Divider style={{ borderColor: '#e9ecef', margin: screens.md ? '24px 0' : '16px 0' }} />
        <Title level={screens.md ? 3 : 4} style={{ color: '#4361ee', marginBottom: screens.md ? '16px' : '12px' }}>我们的使命</Title>
        <Paragraph style={{ fontSize: screens.md ? '16px' : '14px' }}>
          我们致力于为开发者提供高效、便捷的包管理服务，帮助开发者快速找到所需的包信息，提高开发效率。
        </Paragraph>
        
        <Divider style={{ borderColor: '#e9ecef', margin: screens.md ? '24px 0' : '16px 0' }} />
        <Title level={screens.md ? 3 : 4} style={{ color: '#4361ee', marginBottom: screens.md ? '16px' : '12px' }}>支持的第三方服务</Title>
        <Paragraph style={{ fontSize: screens.md ? '16px' : '14px' }}>
          我们目前支持 AppsFlyer 和 Adjust 两种第三方服务的包数据，未来将会支持更多的第三方服务。
        </Paragraph>
        
        <Divider style={{ borderColor: '#e9ecef', margin: screens.md ? '24px 0' : '16px 0' }} />
        <Title level={screens.md ? 3 : 4} style={{ color: '#4361ee', marginBottom: screens.md ? '16px' : '12px' }}>联系我们</Title>
        <Paragraph style={{ fontSize: screens.md ? '16px' : '14px' }}>
          如果您有任何问题或建议，请发送邮件至：<a href="mailto:contact@emusprint.com" style={{ color: '#4361ee', wordBreak: 'break-all' }}>contact@emusprint.com</a>
        </Paragraph>
      </Space>
    </Card>
  );
};

export default AboutPage;